async function getContextData(handle){
    
    const response = await fetch(window.Shopify.routes.root + `products/${handle}?view=context`, {

        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      return data;
}

async function getSectionTemplate(id, handle){
    const response = await fetch(window.Shopify.routes.root + `products/${handle}?id=${id}&sections=pdp-product-minimal`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      return data; 
}

async function getProduct(handle){
    const response = await fetch(window.Shopify.routes.root + `products/${handle}.js`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      return data; 
}


const container = document.querySelector('div[data-snippet-type="modal"]');

// Initialize a new instance of MutationObserver
const observer = new MutationObserver((mutationsList) => {
    for (let mutation of mutationsList) {
        // Check if new nodes are added
        if (mutation.type === 'childList') {
            for (let addedNode of mutation.addedNodes) {
                // Here, you can perform actions on the newly added nodes
                
                console.log('added child');
                let documentSection = document.querySelector('div[data-snippet-type="modal"] div[data-snippet-type="pdp-product-form"] script[data-context]').textContent;
                
                


                
                //let documentSection = JSON.parse($('div[data-snippet-type="modal"] script#product_info').textContent);
                 window.currentPdpProduct = JSON.parse(documentSection);

                // If you want to observe the intersection of the newly added node
                const intersectionObserver = new IntersectionObserver((entries) => {
                    for (let entry of entries) {
                        if (entry.isIntersecting) {
                            console.log('Node is now visible!', entry.target);
                        }
                    }
                });
                intersectionObserver.observe(addedNode);
            }
        }
    }
});

// Configuration for the observer
const config = {
    childList: true, // Observe when child elements are added or removed
};

// Start observing the container
observer.observe(container, config);



var mouseState = true;


function openQuickView(){
    let id = window?.currentPdpProduct?.pid;
    let elemn = $('button.pdp-product-buttons__view[data-snippet-pid='+id+']').find('section.shopify-section:first');
    $('main div[data-snippet-type="modal"]').attr('data-pid',id).html(elemn).addClass('active showing'); 
}




$(document).on('click','.active_frequency', function(){

    $(this).parent().toggleClass('active');
});
$(document).on('change', 'input[name="purchase_type"]', function() {
    $('label.pdp-product-form__recharge__purchase-type').removeClass('active');
    if ($(this).val() == 'onetime') {
    $('#custom-purchase-type').text('PURCHASE: ONE-TIME')
    $('label.pdp-product-form__recharge__purchase-type--onetime').addClass('active')
    $('.frequency_box').removeClass('active');
    $('#subscription_recharge_pdp').parent().siblings('.point_box').removeClass('active');
    } else {
    $(this).parent().siblings('.point_box').addClass('active');
    $('#custom-purchase-type').text('PURCHASE: SUBSCRIPTION')
    $('label.pdp-product-form__recharge__purchase-type--autodeliver').addClass('active')
    }
});

    $(document).on('change', 'input[name="selling_plan"]', function(){
        const chargeInterval = $.trim($(this).siblings('span').children('span.units').text());

        $('label.active_delivery_frequency span').text(chargeInterval);
        $('.frequency_box').removeClass('active');
    });

    $(document).on('click', 'input[name="selling_plan"]', function(){
        $('.frequency_box').removeClass('active'); 
    })



